var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";

import StoryCard from "../../../components/Library/StoryCard";
import NewsletterHeader from "../NewsletterHeader";

import styles from "./Newsletter.css";

var Newsletter = function (_Component) {
  _inherits(Newsletter, _Component);

  function Newsletter() {
    _classCallCheck(this, Newsletter);

    return _possibleConstructorReturn(this, (Newsletter.__proto__ || Object.getPrototypeOf(Newsletter)).apply(this, arguments));
  }

  _createClass(Newsletter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hash = window.location.hash;
      if (hash !== "") {
        var element = document.getElementById(hash.slice(1));
        if (element) {
          setTimeout(function () {
            return element.scrollIntoView();
          }, 2000);
        }
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var newsletter = this.props.newsletter;

      if (!newsletter) return null;

      return React.createElement(
        "div",
        null,
        React.createElement(StoryCard, {
          key: "intro-" + newsletter.id,
          hideFooter: true,
          className: styles.story,
          header: React.createElement(NewsletterHeader, { newsletter: newsletter }),
          story: { blocks: newsletter.intro },
          storyType: "newsletter" }),
        newsletter.chunks.map(function (chunk, index) {
          return React.createElement(
            "div",
            { key: chunk.id },
            React.createElement("div", { id: "story" + index, className: styles.anchor }),
            React.createElement(StoryCard, {
              story: chunk,
              className: styles.story,
              hideHeader: true,
              storyType: "newsletter" })
          );
        }),
        React.createElement(StoryCard, {
          key: "outro-" + newsletter.id,
          hideHeader: true,
          hideFooter: true,
          className: styles.footer,
          story: { blocks: newsletter.outro },
          storyType: "newsletter" })
      );
    }
  }]);

  return Newsletter;
}(Component);

Newsletter.propTypes = {
  newsletter: PropTypes.object
};

export default Newsletter;


// WEBPACK FOOTER //
// ./src/subscriptions/components/Newsletter/Newsletter.js